import { isDemo, isDev, isProd, isStaging } from './env';
import { environment } from './environment';

export const getApiURL = (): string => {
  if (isProd()) {
    return window.location.host === 'old.app.in-pool.ch'
      ? 'https://old.api.in-pool.ch'
      : 'https://api.in-pool.ch';
  } else if (isStaging()) return 'https://staging.api.in-pool.ch';
  else if (isDev()) return 'https://dev.api.in-pool.ch';
  else if (isDemo()) return 'https://demo.api.in-pool.ch';
  else {
    // For local development, use environment backendPort setting
    const backendPort = environment.backendPort || '3000';
    return `http://localhost:${backendPort}`;
  }
};
